/* ===========================================================================
 * SESION DE LA CONSOLA — login PROPIO de `taxi`
 * ===========================================================================
 *
 * ⛔ **CORREGIDO 2026-09-05: este archivo decia que las rutas eran una PROPUESTA
 * ("ninguna se llamo nunca: el backend todavia no existe") y que la consola
 * usaba `auth-jj`. LAS DOS COSAS DEJARON DE SER CIERTAS.** Las rutas existen —
 * las sirve `apps/api/src/auth/sesion.controller.ts` — y la identidad ya no la
 * pone `auth-jj`.
 *
 * POR QUE CAMBIO (`docs/06` §13, no es preferencia)
 *   `auth-jj` no tiene registro de clientes ni concepto de `issuer`/`audience`:
 *   ni una tabla ni un campo, para NINGUN consumidor. Sin `aud`, validar solo la
 *   firma significa que **una sesion emitida para otra app del portafolio
 *   autentica en la consola**, y como su cookie es de dominio `.argusapps.net`
 *   el navegador la manda sola. El backend exigia esos dos valores para no
 *   arrancar sobre esa premisa ⇒ no se podia desplegar.
 *
 * 🔑 LO QUE **NO** CAMBIA, Y ES EL INVARIANTE DE ESTE ARCHIVO
 *   El navegador sigue sin ver ningun token. La consola no lo lee, no lo guarda
 *   y no lo manda: llama con `credentials: 'include'` y el navegador adjunta la
 *   cookie `httpOnly`. **Si aparece codigo de esta consola leyendo, guardando o
 *   pasando un token, esta mal por construccion.**
 *
 *   Lo que cambia es QUIEN emite la cookie y con que alcance: la emite `taxi`,
 *   es del HOST exacto de la API (prefijo `__Host-`, sin `Domain=`) y no la ve
 *   ninguna otra app. Eso, por construccion, elimina la superficie cruzada.
 *
 * LO QUE SI CAMBIO PARA ESTA APP
 *   `ingresar` ya NO es una redireccion del navegador hacia un proveedor
 *   externo: es un formulario de DOS pasos contra nuestra propia API —
 *   correo → codigo por correo → sesion. Por eso hay una ruta mas que antes.
 *
 * ⚠️ LO QUE SIGUE SIN VERIFICARSE POR EFECTO
 *   Nadie corrio este flujo en un NAVEGADOR: no hay despliegue ni navegador en
 *   la sesion que escribio esto. Lo que si esta probado, con controles
 *   negativos, es el lado del backend (`sesion.integration.spec.ts`, HTTP real).
 *   Lo que falta comprobar es de navegador: que la cookie `__Host-` se acepte y
 *   viaje, incluido `http://localhost` en desarrollo.
 *
 * QUE FALTA, Y NO ES DE ESTE ARCHIVO
 *   - El ROL: el backend tiene UNA columna booleana (`esAdminPlataforma`) y esta
 *     consola modela dos roles. Hoy `/sesion` siempre devuelve `administrador`,
 *     que es lo que el backend REALMENTE autoriza (`OperadorGuard` no distingue).
 *     Para que la distincion sea real hace falta una columna de rol y que el
 *     guard la exija. Ver `docs/06` §13.
 *   - Como se marca a alguien como operador: sigue siendo el [PENDIENTE] que ya
 *     estaba abierto antes de este cambio.
 * =========================================================================== */

import { entorno } from '../config/entorno';

/** Rutas REALES contra `VITE_API_URL`. Servidas por `auth/sesion.controller.ts`. */
export const RUTAS_SESION = {
  /** GET — la sesion vigente. 401 si no hay; 403 (con `correo`) si hay y no tiene rol. */
  actual: '/sesion',
  /** POST {correo} — manda el codigo al correo. Responde 202 SIEMPRE (no es un oraculo). */
  codigo: '/sesion/codigo',
  /** POST {correo, codigo} — verifica y abre la sesion (emite la cookie). */
  ingresar: '/sesion',
  /** POST — cierra la sesion y borra la cookie. Idempotente. */
  salir: '/sesion/salir',
} as const;

export const urlDe = (ruta: string): string => `${entorno.apiUrl}${ruta}`;
